import { makeStyles } from '@material-ui/core';
import { StateConfig } from 'src/common/interfaces/dtos/ITouchpointTheme';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles({
  grid: {
    height: '100%',
    width: '100%',
    backgroundImage: ({ backgroundImageURL }: StateConfig) =>
      backgroundImageURL ? `url(${backgroundImageURL})` : '',
    backgroundColor: ({ backgroundColor }: StateConfig) =>
      backgroundColor ?? themeColor.trainingBackground,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    fontFamily: 'Raleway',
  },
  customerCartLogo: {
    width: '100%',
    maxWidth: '360px',
  },
  cartContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: ({ headingTextColor }: StateConfig) => headingTextColor ?? 'white',
    textAlign: 'center',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '4vw',
    fontFamily: 'Raleway',
    whiteSpace: 'nowrap',
    marginTop: '6.77vh',
  },
  text2: {
    color: ({ bodyTextColor }: StateConfig) => bodyTextColor ?? themeColor.lockTextColor,
    textAlign: 'center',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '2.5vw',
    fontFamily: 'Raleway',
    whiteSpace: 'nowrap',
    marginBottom: '15vh',
  },

  versionLabel: {
    position: 'absolute',
    zIndex: 999,
    color: 'white',
    bottom: '2.47vh',
    left: '3.3vw',
    fontSize: '1.3vh',
    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  label: {
    position: 'absolute',
    left: '1%',
    right: 'auto',
    bottom: '1%',
    height: 'auto',
    width: '6%',
  },
  logo: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    left: 'auto',
    right: '0',
    bottom: '0',
    height: 'auto',
    width: '10%',
  },
  trainingWatermarkContainer: {
    position: 'relative',
  },
  trainingModeBackground: {
    backgroundColor: `${themeColor.trainingBackground}!important`,
  },

  trainingWaterMark: {
    right: 0,
    '@media (min-width: 1024px)': {
      fontSize: '2.8rem',
    },
    '@media (min-width: 1280px)': {
      fontSize: '3.2rem',
    },
    '@media (min-width: 1366px)': {
      fontSize: '3.5rem',
    },
    '@media (min-width: 1600px)': {
      fontSize: '4.6rem',
    },
    '@media (min-width: 1920px)': {
      fontSize: '5.6rem',
    },
  },
});
